import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { omit } from "lodash-es";
import { useAtom } from "jotai";

import { getEmissionWMSOverLayer } from "src/utils/emission.utils";
import { EmissionType, HistoryState } from "src/types";
import { useEmission } from "src/hooks/emissions";
import { addOrUpdateActiveOverlayerAtom } from "src/atoms/overlayers";

interface Props {
  type: EmissionType;
  params: {
    caseId: string;
    scenarioId: string;
    emissionId: string;
    segmentId?: string;
  };
}

export function EmissionOnMap(props: Props) {
  const [, addOrUpdateActiveOverlayer] = useAtom(addOrUpdateActiveOverlayerAtom);
  const { params } = props;
  const { data: emission } = useEmission(params.scenarioId, params.emissionId, props.type);
  const location = useLocation<HistoryState>();
  const history = useHistory<HistoryState>();
  /**
   * Effects
   */
  // TODO: solve this missing dependencies problem
  useEffect(showEmissionOnMap, [addOrUpdateActiveOverlayer, emission]);

  /**
   * Functions
   */
  function showEmissionOnMap() {
    if (!emission) return;

    const { type, geoserverFilter } = emission;
    const emissionLayer = getEmissionWMSOverLayer(type, geoserverFilter);
    // @ts-ignore: trick setParams with this fake argument to rerender
    // emissionLayer.setParams({ fake: new Date() }, false);

    addOrUpdateActiveOverlayer({
      ...emissionLayer,
      // @ts-ignore: trick params with this fake argument to rerender
      params: { fake: new Date() },
    });

    resetStateAction();

    return function cleanup() {
      // keep the layer in activeLayers list, this keeps zIndex, opacity, ...
      addOrUpdateActiveOverlayer({
        ...emissionLayer,
        isActive: false,
      });
    };
  }

  function resetStateAction() {
    // reset state action
    history.replace(location.pathname, omit(location.state, "action"));
  }

  return render();

  function render() {
    return null;
  }
}
